import React from 'react';
import '../styles/DarkBackground.css';

function DarkBackground() {
    return <div className="dark-bg" />;
}

export default DarkBackground;

